import request from '@/utils/request'

// =========================
// 本地假数据/假接口（用于前端联调）
// - 不依赖后端即可跑通授权书模板新增/编辑/删除
// =========================
const __MOCK_DB__ = {
    templates: [
        {
            id: 3001,
            template_name: '授权书模板-示例A',
            // 文件类型：1授权书 2数字证书协议 3隐私协议
            type: 1,
            contract_imgs: ['http://saassystem.hulianzaowu.cn/f562c639558f1cf94e3c2a22b4015761_compress.jpg'],
            upload_type: '1',
            path: '/mock/path/authA',
            // editcomponent.vue 里用的是 components_arr
            components_arr: [
                { id: 'c1', type: 0, title: '姓名1', position_x: 120, position_y: 180, width: 60, height: 24, font_size: 18 },
                { id: 'c2', type: 8, title: '公司名称1', position_x: 120, position_y: 240, width: 90, height: 24, font_size: 18 }
            ]
        }
    ]
}

function __mockDelay(result, delay = 120) {
    return new Promise((resolve) => setTimeout(() => resolve(result), delay))
}

function __nextTemplateId() {
    const ids = __MOCK_DB__.templates.map(t => t.id)
    return (ids.length ? Math.max.apply(null, ids) : 3000) + 1
}

export function configAdd (data) {
    return request({
        url: '/config/ali_add',
        method: 'post',
        data
    })
}
export function configInfo (data) {
    return request({
        url: '/config/ali_info',
        method: 'post',
        data
    })
}
export function updatePwd (data) {
    return request({
        url: '/updatePwd',
        method: 'post',
        data
    })
}
export function aliEdit (data) {
    return request({
        url: '/config/ali_edit',
        method: 'post',
        data
    })
}
export function aliSmsAdd (data) {
    return request({
        url: '/config/ali_smsadd',
        method: 'post',
        data
    })
}
export function aliSmsInfo (data) {
    return request({
        url: '/config/ali_smsinfo',
        method: 'post',
        data
    })
}
export function aliSsmsEdit (data) {
    return request({
        url: '/config/ali_smsedit',
        method: 'post',
        data
    })
}

export function ormAdd (data) {
    return request({
        url: '/config/orm_add',
        method: 'post',
        data
    })
}

export function ormInfo (data) {
    return request({
        url: '/config/orm_info',
        method: 'post',
        data
    })
}

export function ormEdit (data) {
    return request({
        url: '/config/orm_edit',
        method: 'post',
        data
    })
}

export function operationList (data) {
    return request({
        url: '/operation/list',
        method: 'get',
        params: data
    })
}

export function staffList (data) {
    return request({
        url: '/staff/ls',
        method: 'get',
        params: data
    })
}

export function staffBan (data) {
    return request({
        url: '/staff/is_ban',
        method: 'post',
        data
    })
}

export function staffInfo (data) {
    return request({
        url: '/staff/infos',
        method: 'get',
        params: data
    })
}

export function staffAdd (data) {
    return request({
        url: '/staff/add',
        method: 'post',
        data
    })
}

export function staffEdit (data) {
    return request({
        url: '/staff/edit',
        method: 'post',
        data
    })
}

export function staffDel (data) {
    return request({
        url: '/staff/del',
        method: 'post',
        data
    })
}

export function noticeRead (data) {
    return request({
        url: '/notice/read',
        method: 'post',
        data
    })
}

export function getAnnouncement (data) {
    return request({
        url: '/notice/get_announcement',
        method: 'get',
        params: data
    })
}

export function noticeReadList (data) {
    return request({
        url: '/notice/read_person',
        method: 'get',
        params: data
    })
}
export function sms_channel_switch (data) {
    return request({
        url: '/operation/sms_channel_switch',
        method: 'post',
        data
    })
}

// CA 相关配置保存
export function saveAuthCaConfig (data) {
    return request({
        url: '/config/auth_ca_save',
        method: 'post',
        data
    })
}

export function saveCertCaConfig (data) {
    return request({
        url: '/config/cert_ca_save',
        method: 'post',
        data
    })
}

export function saveEvidenceCaConfig (data) {
    return request({
        url: '/config/evidence_ca_save',
        method: 'post',
        data
    })
}

// 获取CA认证相关配置
export function getConfigInfo (type) {
    return request({
        url: '/config/get_config_info',
        method: 'get',
        params: { type }
    })
}

// 更新CA认证相关配置
export function updateConfigInfo (data) {
    return request({
        url: '/config/up_config_info',
        method: 'post',
        data
    })
}

// 授权协议相关接口
// 获取授权协议列表
export function getLicenseAgreementList (data) {
    return request({
        url: '/license_agreement/list',
        method: 'get',
        params: data
    })
}

// 新增授权协议
export function addLicenseAgreement (data) {
    return request({
        url: '/license_agreement/add',
        method: 'post',
        data
    })
}

// 编辑授权协议
export function editLicenseAgreement (data) {
    return request({
        url: '/license_agreement/edit',
        method: 'post',
        data
    })
}

// 删除授权协议
export function deleteLicenseAgreement (data) {
    return request({
        url: '/license_agreement/delete',
        method: 'post',
        data
    })
}

// 切换授权协议使用状态
export function toggleLicenseAgreementStatus (data) {
    return request({
        url: '/license_agreement/toggle_status',
        method: 'post',
        data
    })
}

// 获取模板列表
export function getTemplateList (data) {
    return request({
        url: '/config/get_template_list',
        method: 'get',
        params: data
    })
}

// 设置模板状态（启用/禁用）
export function setTemplateStatus (data) {
    return request({
        url: '/config/set_template_status',
        method: 'post',
        data
    })
}

// 删除模板
export function delTemplate (data) {
    return request({
        url: '/config/del_template',
        method: 'post',
        data
    })
}

// 上传模板文件
export function uploadTemplateFile (formData) {
    return request({
        url: '/config/uploads',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
//
// 上传文件
export function uploadFileToPng (data) {
    return request({
        url: '/config/up_filetype',
        method: 'post',
        data: data,
    })
}

// 新增/修改模板
export function upTemplate (data) {
    return request({
        url: '/config/up_template',
        method: 'post',
        data
    })
}

// 获取模板详情
export function getTemplateDetails (data) {
    return request({
        url: '/config/get_template_details',
        method: 'get',
        params: data
    })
}

// =========================
// 授权书模板（operation 里补“假的 api 接口”）
// 供：src/pages/operation/components/createtemplate.vue
// 供：src/pages/operation/components/editcomponent.vue
// =========================

// 新增模板
export function addtemplate (data) {
    const newId = __nextTemplateId()
    const tpl = Object.assign(
        {
            id: newId,
            template_name: data && data.template_name ? data.template_name : `授权书模板-${newId}`,
            type: data && data.type ? data.type : 1,
            contract_imgs: data && data.contract_imgs ? data.contract_imgs : [],
            upload_type: data && data.upload_type ? data.upload_type : '1',
            path: data && data.path ? data.path : `/mock/path/${newId}`,
            components_arr: data && data.assembly_arr ? data.assembly_arr : []
        },
        {}
    )
    __MOCK_DB__.templates.unshift(tpl)
    return __mockDelay({ code: 200, msg: '新增模板成功', data: tpl })
}

// 上传后将文件转图片（这里直接返回假图片列表）
export function edittempupdate (data) {
    // 兼容 createTemplate 里调用：edittempupdate({ path:e.data.src, type:"1" })
    const imgs = [
        'http://saassystem.hulianzaowu.cn/f562c639558f1cf94e3c2a22b4015761_compress.jpg'
    ]
    return __mockDelay({
        code: 200,
        msg: '解析成功',
        data: {
            type: (data && data.type) ? Number(data.type) : 1,
            upload_type: (data && data.type) ? data.type : '1',
            imgs,
            path: (data && data.path) ? data.path : '/mock/upload/path'
        }
    })
}

// 删除上传临时文件/模板
export function deletetmp (data) {
    // 兼容 deletetmp({contract_path: this.formItem.contract_imgs})
    void data
    return __mockDelay({ code: 200, msg: '删除成功', data: true })
}

// 模板详情
export function info (data) {
    const id = data && data.id
    const tpl = __MOCK_DB__.templates.find(t => t.id === id) || __MOCK_DB__.templates[0]
    return __mockDelay({ code: 200, msg: 'ok', data: tpl })
}

// 编辑模板
export function edittemplate (data) {
    const id = data && (data.id || data.template_id)
    const idx = __MOCK_DB__.templates.findIndex(t => t.id === id)
    if (idx >= 0) {
        __MOCK_DB__.templates[idx] = Object.assign({}, __MOCK_DB__.templates[idx], {
            template_name: data.template_name,
            type: data.type || __MOCK_DB__.templates[idx].type || 1,
            contract_imgs: data.contract_imgs,
            upload_type: data.upload_type,
            path: data.path,
            components_arr: data.assembly_arr || data.components_arr || __MOCK_DB__.templates[idx].components_arr
        })
        return __mockDelay({ code: 200, msg: '编辑成功', data: __MOCK_DB__.templates[idx] })
    }
    return __mockDelay({ code: 500, msg: '模板不存在', data: null })
}